import { commitMutation, graphql } from 'react-relay';

const mutation = graphql`
  mutation FinishPaypalExpressPaymentMutation($input: FinishPaypalExpressPaymentInput!) {
    finishPaypalExpressPayment(input: $input) {
      order {
        id
        orderid
        state
      }
    }
  }
`;

function commit(environment, orderId, callback) {
  return commitMutation(environment, {
    mutation,
    variables: {
      input: {
        orderId,
      },
    },
    onCompleted: (response, errors) => {
      if (errors) {
        callback && callback(errors[0]);
      } else {
        callback && callback(null, response.finishPaypalExpressPayment.order);
      }
    },
    onError: err => {
      callback && callback(err);
    },
  });
}

export default { commit };
